export type ContractType = "CDI" | "CDD" | "EXTRA" | "MAD" | "INTERIM";

export const allContractTypes: ContractType[] = [
  "CDI",
  "CDD",
  "EXTRA",
  "MAD",
  "INTERIM",
];

export function contractTypeFromString(str: string): ContractType {
  if (allContractTypes.includes(str as ContractType)) {
    return str as ContractType;
  }
  throw new Error(`Unknown ContractType: ${str}`);
}
